<template lang="pug">

v-main
  v-container(v-show="viewMode == 'list'", fluid)
    v-dialog(v-model='dialog' persistent='' width='30%')
      template(v-slot:activator='{ props }')
      v-card
        v-card-title.text-h1(style="justify-content: center;")
          i(style= "font-size: 80px !important;" class='material-icons size-18 color-red') highlight_off
        v-card-text(style= "font-size: 24px; color:#000000; text-align: center;") Are You Sure?
        v-card-text(style= "font-size: 16px; color:#555555; text-align: center;") Do you really want to delete these record? This process cannot be undone.
        div(style="display: flex;")
          v-btn(style="flex: 1; margin: 1rem;" @click='dialog = false')
            | Cancel
          v-btn(style="flex: 1; margin: 1rem; background-color: #FF5252; color:#fff" @click='confirmDelete')
            | Delete
    v-flex
      v-card
        v-toolbar.elevation-0(color="white")
          v-toolbar-title(v-model="title") CMS Bank
          v-spacer
          v-btn.elevation-0(
            dark,
            color="blue-secondary",
            @click="viewMode = 'create'"
          ) CREATE
        v-divider
        v-toolbar.elevation-0.mt-2.mb-4(color="white")
          v-text-field.hidden-sm-and-down.col-12(
            flat,
            append-icon="search",
            placeholder="Keyword (optional)",
            v-model="keyword",
            hide-details
          )
        v-divider
        v-card-text.pa-0
          v-data-table(
            :headers="dataHeaders",
            :items="dataItems",
            :search="keyword"
          )
            template(v-slot:item.data-table-expand="{ headers, item }")
              v-icon.mr-2(
                title="Edit",
                color="green",
                @click="editMode(item)"
              )
                | edit
              v-icon.mr-4.red-dark(
                title="Delete",
                color="#FF5252",
                @click="deleteMode(item._id)"
              )
                | delete

            template(v-slot:no-data)
              .pa-15 
                |
                |
                |
                |
                |
                |
                img(src="../assets/icon/empty-users.png")
                .empty__title.mt-1 Data not found
                .empty__subtitle Data is empty or Try adjusting your filters.

            template(v-slot:no-results)
              .pa-15 
                |
                |
                |
                |
                |
                |
                img(src="../assets/icon/empty-users.png")
                .empty__title.mt-1 Data not found
                .empty__subtitle Data is empty or Try adjusting your filters.
  v-container(v-show="viewMode == 'create' || viewMode == 'edit'", fluid)
    v-card
      v-toolbar.elevation-0(color="white")
        v-toolbar-title(v-if="viewMode == 'create'") Create Bank
        v-toolbar-title(v-if="viewMode == 'edit'") Edit Bank
      v-divider
      v-card-text
        v-row(no-gutters)
          v-col(cols="2") 
            |
            v-subheader(color="black") Bank Name
          v-col(cols="10")
            v-text-field(v-model="createData.text" label="Bank Name")
        v-row(no-gutters)
          v-col(cols="2") 
            |
            v-subheader(color="black") Bank Alias

          v-col(cols="10")
            v-text-field(v-model="createData.alias" label="Bank Alias")
            //- <div id="containere">
            //-   <textarea id="editor" name="editor"></textarea>
            //- </div>
        //- v-row(no-gutters)
        //-   v-col(cols="2") 
        //-     |
        //-     v-subheader(color="black") Bank Code
        //-   v-col(cols="10")
        //-     v-text-field(type="number" v-model="createData.value" label="Bank Code")
        //- v-row(no-gutters)
        //-   v-col(cols="2") 
        //-     |
        //-     v-subheader(color="black") Order
        //-   v-col(cols="10")
        //-     v-text-field(type="number" v-model="createData.order" label="Order")
        v-card-actions.my-8
          v-btn.custom__padding-btn(@click="cancle") Back
          v-btn.custom__padding-btn(style="background-color:#006bff; color: white" v-if="viewMode == 'create'" @click="create") Create
          v-btn.custom__padding-btn(style="background-color:#006bff; color: white" v-if="viewMode == 'edit'" @click="edit") Update
</template>

<script>
import axios from "axios";
export default {
  name: "UserList",
  props: {
    title: String,
  },
  data() {
    return {
      dialog: false,
      editID: "",
      createData: {
        _id: "",
        value: "",
        alias: "",
        text: "",
        order: "",
      },
      viewMode: "list",
      editor: null,
      keyword: "",
      dataStatus: ["All", "Active", "Non Active"],
      group: ["All", "Admin", "User"],
      business_unit: [],
      dataHeaders: [
        { text: "Bank Name", value: "text" },
        //- { text: "Bank Code", value: "value" },
        { text: "Alias Bank", value: "alias" },
        { text: "Actions", value: "data-table-expand" },
      ],
      dataItems: [],
      isSuperAdmin: false,
      users: [],
      status: "",
    };
  },
  methods: {
    cancle() {
      this.viewMode = 'list'
      //- myEditor.setData("")
      this.createData._id = ""
      //- this.createData.value = ""
      //- this.createData.order = ""
      this.createData.alias = ""
      this.createData.text = ""
      this.getFaqList()
    },
    create() {
      if ( this.createData.text.length == 0 || this.createData.text.trim() == '') this.$toasted.error("Bank name should not be empty.", { icon : 'error'});
      else {
        let token = localStorage.getItem("token");
        axios
          .post(process.env.VUE_APP_API_OLD + `/api/list_bank`, {
            //- order: +this.createData.order,
            //- value: this.createData.value,
            alias: this.createData.alias,
            text: this.createData.text,
          }, {
            headers: { Authorization: `Bearer ${token}` },
          })
          .then((res) => {
            this.getFaqList()
            this.$toasted.success("Success! Data has been created.", { icon : 'check_circle'});
            this.viewMode = 'list'
            this.createData._id = ""
            //- this.createData.value = ""
            this.createData.alias = ""
            this.createData.text = ""
            //- this.createData.order = ""
          })
          .catch((err) => {
            //- console.log(error)
            let error = err.response.data.error || 'Err'
            if (error != 'Err') this.$toasted.error(error, { icon: "error" });
            else this.$toasted.error(err, { icon: "error" });
          })
      }

    },
    edit() {
      if ( this.createData.text.length == 0 || this.createData.text.trim() == '') this.$toasted.error("Bank name should not be empty.", { icon : 'error'});
      else {
        let token = localStorage.getItem("token");
        axios
          .put(process.env.VUE_APP_API_OLD + `/api/list_bank?edit_id=${this.editID}`, {
            //- order: +this.createData.order,
            //- value: this.createData.value,
            alias: this.createData.alias,
            text: this.createData.text,
          }, {
            headers: { Authorization: `Bearer ${token}` },
          })
          .then((res) => {
            this.getFaqList()
            this.$toasted.success("Success! Data has been update.", { icon : 'check_circle'});
            this.viewMode = 'list'
            myEditor.setData("")
            this.createData.title = ""
          })
          .catch((err) => {
            //- console.log(error)
            let error = err.response.data.error || 'Err'
            if (error != 'Err') this.$toasted.error(error, { icon: "error" });
            else this.$toasted.error(err, { icon: "error" });
          })
      }
      
    },
    editMode(item) {
      this.editID = item._id
      this.viewMode = "edit"
      //- myEditor.setData(item.description)
      this.createData._id = item._id
      this.createData.text = item.text
      //- this.createData.value = item.value
      this.createData.alias = item.alias
      //- this.createData.order = item.order
    },
    deleteMode(id) {
      this.editID = id
      this.dialog = true
    },
    confirmDelete() {
      this.dialog = false
      let token = localStorage.getItem("token");
      axios
        .delete(process.env.VUE_APP_API_OLD + `/api/list_bank?delete_id=${this.editID}`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => {
          this.getFaqList()
          this.viewMode = 'list'
          this.$toasted.error('Success! Data has been deleted.', { icon : 'check_circle'})
        })
        .catch((err) => {
          this.$toaster.error(err, { icon: "error" });
        })
        .finally(() => {
          this.dialog = false
        });
    },
    getFaqList() {
      let token = localStorage.getItem("token");
      axios
        .get(process.env.VUE_APP_API_OLD + `/api/list_bank?page=cms`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => {
          this.dataItems = res.data
        })
        .catch((err) => {
          this.$toaster.error(err, { icon: "error" });
        })
        .finally(() => (this.loading = false));
    },
    statusFilter(val) {
      if (this.status == "All") {
        return true;
      }

      if (!this.status) {
        return true;
      }
      return val === this.status;
    },
  },
  mounted() {
    this.getFaqList()
  },
  created() {
    let recaptchaScript = document.createElement('script')
    recaptchaScript.setAttribute('src', '/js/local.js')
    document.body.appendChild(recaptchaScript)
  }
};
</script>

<style>
.pointer {
  cursor: pointer;
}

#containere div .ck-editor__main .ck-restricted-editing_mode_standard ol li {
  margin-bottom: 1em;
}
</style>
